/**
 * Read the `listing_id` query param from a URL search string. The partial-sale
 * notification email deep-links to `/succession/my_partial_sales?listing_id=<id>`;
 * the My Partial Sales page uses this to scroll to / highlight that listing (the
 * one whose inquiry triggered the email).
 *
 * @param {string} search - a URL query string (e.g. window.location.search)
 * @returns {string|null} the listing id, or null when absent/blank
 */
export const focusListingIdFromSearch = (search) => {
  try {
    const value = new URLSearchParams(search || '').get('listing_id');
    return value && value.trim() ? value.trim() : null;
  } catch (e) {
    return null;
  }
};

export default focusListingIdFromSearch;
